import { CLIENT_ROLES } from 'resources/user/user.constants';

export const DEAL_TYPES = {
  BUYER: CLIENT_ROLES.BUYER,
  SELLER: CLIENT_ROLES.SELLER,
};

export const DEAL_STAGES = {
  PRE_CONTRACT: 'Pre Contract',
  PRE_CONTRACT_ACTIVE_LISTING: 'Pre Contract (Active Listing)',
  PRE_CONTRACT_HOME_SEARCH: 'Pre Contract (Home search)',
  PRE_CONTRACT_MAKE_OFFER: 'Pre Contract (Make Offer)',
  UNDER_CONTRACT: 'Under Contract',
};

export const COMPLETE_MODE_TYPES = {
  MARK_ALL_COMPLETED: 'mark_all_completed',
  MARK_ALL_SKIPPED: 'mark_all_skipped',
};

// TODO: delete coming soon status
export const DEAL_NOT_STARTED_STATUSES = {
  PRE_LISTING: 'coming_soon',
  ACTIVE_LISTING: 'active_listing',
  HOME_LISTED_COMPLETED: 'home_listed_completed', // 'Home Listed' milestone is complete
};

export const DEAL_STARTED_STATUSES = {
  ACTIVE: 'active', // showing: # days to close
};

export const DEAL_ENDED_STATUSES = {
  VOIDED: 'voided',
  CLOSED: 'closed',
};

export const DEAL_BUYER_NOT_STARTED_STATUSES = {
  OFFER_PENDING: 'offer_pending',
  HOME_SEARCH: 'home_search',
};

export const DEAL_STATUSES = {
  ...DEAL_NOT_STARTED_STATUSES,
  ...DEAL_STARTED_STATUSES,
  ...DEAL_ENDED_STATUSES,
  ...DEAL_BUYER_NOT_STARTED_STATUSES,
};

export const TRANSACTION_FLOW_STEPS = {
  SELECT_CLIENT: 'selectClients',
  CHOOSE_TRANSACTION_TYPE: 'chooseTransactionType',
  TRANSACTION_DETAILS: 'transactionDetails',
  SELECT_UNDER_CONTRACT_LISTED_KIT: 'selectUnderContractListedKit',
  SELECT_LISTED_KIT: 'selectListedKit',
};

export const HOME_SEARCH_IN_PROGRESS = 'Home Search In-Progress';

export const AUDIT_NEEDED_STATUS = 'Review Needed';

export const TRANSACTION_CREATED_FIELD = {
  LABEL: 'Transaction Created Date',
  NAME: 'created_on',
};

export const TRANSACTION_PARTIES = {
  CLIENTS: 'clients',
  AGENT: 'agent',
  COORDINATOR: 'coordinator',
};
